import isFunction from 'lodash/isFunction'
import React from 'react'
import type { FieldAttributes, FieldProps as FieldPropsCore } from 'formik'
import { Field as FieldCore } from 'formik'
import { FieldEditor } from './FieldEditor'
import { TextInput } from '@ztechapps/webui.input'

export type FormFieldProps = FieldAttributes<any> & { component: any; help: string; label: string }

export const Field = ({ component, name, onChange, onBlur, help, label, ...rest }: FormFieldProps) => {
  component = component ?? TextInput
  return (
    <FieldCore name={name} {...rest}>
      {(fieldProps: FieldPropsCore) => {
        if (onChange) {
          if (!isFunction(onChange)) {
            onChange = (e) => fieldProps.form.setFieldValue(name, e)
            onBlur = (e) => fieldProps.form.setFieldTouched(name, e)
          }
        } else {
          onChange = fieldProps.field.onChange
          onBlur = fieldProps.field.onBlur
        }

        return (
          <FieldEditor
            onChange={onChange}
            onBlur={onBlur}
            name={name}
            componentProps={rest}
            component={component}
            fieldProps={fieldProps}
            help={help}
            label={label}
          />
        )
      }}
    </FieldCore>
  )
}
